import React from 'react';

export default function Separator() {
    return (
        <div className={'separator'} />
    );
}